export enum UrlStateParameters {
  reportId = 'r',
  selectedDispersionMode = 'dm',
  dispersionModeTotal = 't',
  dispersionModeCarry = 'c',
  showNormalizedData = 'nd',
  optimizerOn = 'op',
  skidAndRollOn = 'sro',
  dispersionOn = 'do',
  trajectoryOn = 'to',
  videoOn = 'vo',
  clubDataOn = 'cdo',
  selectedOptimizedType = 'ot',
  selectedOptimizerView = 'ov',
  optimizerViewData = 'd',
  optimizerViewTrajectory = 't',
  measurementParameters = 'mp',
  unitPresentation = 'u',
  selectedView = 'v',
  selectedStroke = 'ss',
  selectedGroupOfStrokes = 'sgos',
  selectedGroupColor = 'sgc',
  selectedStrokeClub = 'sc',
  hiddenShots = 'hs',
  selectedVideoAngles = 'sva',
  printVersion = 'p',
  readFromUrl = 'rfu',
  // Normalization settings
  altitude = 'nd_altitude',
  temperature = 'nd_temperature',
  ballType = 'nd_ballType',
  altitudeUnit = 'nd_altitudeUnit',
  temperatureUnit = 'nd_temperatureUnit',
}
